import React from 'react';
import { useState, useEffect } from 'react';
import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import ChineseClass from './ChineseClass';

const ClassGrade2 = () => {

  const this_class = {
    课程名称: "中文二年级",
    课程介绍:
    `
     继续教授与儿童日常生活紧密相关的生活用语，同时也使学生能认读一定量的汉字，
     正确地使用简单的中文会话，包括使用完整的句子和正确的发音。
     以轻松活泼的形式,寓教学于娱乐之中.
     `,
    教学语言: "中文",
    教学大纲: "Mon, Wed, Fri - 10:00 AM to 12:00 PM",
    课程内容: "",
    教学目的: "1. 学习与日常生活相关的中文词汇和表达方式。",
    授课方法: "通过游戏、歌曲和故事等多种形式，激发学生的学习兴趣，培养他们的语言能力。",
    教材: 
    `
    《中文练习册第九册A》    中国暨南大学华文学院编写2018年版
    《中文练习册第九册B》    中国暨南大学华文学院编写2018年版
  `,
    作业: "每周布置适量的作业，帮助学生巩固所学知识，并培养良好的学习习惯。",
    考核方法: `
    • 出席及课堂参与5%
    • 平时测验10%
    • 作业15%
    • 期中考试35%
    • 期末考试35%
    `
  };

  return (
    <>
        <Box height={100} />
          <ChineseClass class_introduction={this_class} />
        <Box sx={{ height: '80px' }}></Box>
    </>
  )
}

export default ClassGrade2